import { Component, OnInit, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SignatureService } from '../services/signature.service';
import { SignatureState } from '../models/signatureState.model';
import { HttpServices } from '../services/http.service';

import * as config from '../config/config';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '@fortawesome/fontawesome-svg-core';
import { SignStatus } from '../models/SignStatus.enum';
import { ReferenceService } from '../services/reference.service';

import { SEPALinkInformationFromQuoteResponse } from '../models/purchaseOrder/SEPALinkInformationFromQuoteResponse.model';

import { HttpStatus } from '../models';
import { faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LoaderService } from '../services/loader.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TrackingService } from '../services/tracking.service';

@Component({
  selector: 'fs-purchase-orders-sign',
  styleUrls: ['./purchase-orders-sign.sass'],
  templateUrl: './purchase-orders-sign.component.html'
})

export class PurchaseOrdersSignComponent implements OnInit {

  private docId: string;
  private hashSecurity: string;
  idStatus: SignStatus;
  signStatus = SignStatus;
  signatureState = SignatureState;
  returnSignature: boolean = false;

  public hasValidSepaMandate: boolean;

  validateErrors: boolean = false;

  signatureSepaErrorState: SignatureState;
  faTimes = faTimes;
  isPayer: boolean;
  isOrderAndSepaSign: boolean = false;
  unsignedBdcPdf: SafeResourceUrl;
  pageTitle: string;
  isBlockingError: boolean;
  isErrorReport: boolean = false;
  isErrorSent: boolean = false;
  errorText: string;
  faInfoCircle = faInfoCircle;

  constructor(
    private signatureService: SignatureService,
    private sanitizer: DomSanitizer,
    private loaderService: LoaderService,
    private httpServices: HttpServices,
    private route: ActivatedRoute,
    private referenceService: ReferenceService,
    private router: Router,
    private domSanitize: DomSanitizer,
    private ngxSmartModalService: NgxSmartModalService,
    private trackingService: TrackingService) {

    let param: Params;
    this.route.params.subscribe(params => param = params);
    this.docId = param['doc-id'];
    this.hashSecurity = param['hash-secu'];
  }

  // event.data.event_id: redirect; event.data.status :[OK,CANCEL]
  @HostListener('window:message', ['$event'])
  public returnInfoSignBdc(event: any): void {
    if (event.data.event_id === 'redirect') {
      this.returnSignature = true;

      if (event.data.status === 'OK') {
        this.idStatus = SignStatus.SIGNED;
        this.trackingService.pushEvent('financial-bdc_signature-confirmation');
      } else if (event.data.status === 'CANCEL') {
        this.idStatus = SignStatus.CANCELED;
      }
    }
  }

  // Call the API to get the Url to display in the Iframe
  private getUrlSignature(): void {
    this.loaderService.increaseLoaderCount();
    // tslint:disable: deprecation
    this.httpServices.getWithoutAuth<any>(this.referenceService.staticReferences.Action[config.ApiKeys.GET_URL_IFRAME_SIGN]
      .replace('{0}', this.docId).replace('{1}', this.hashSecurity), () => { }).subscribe(
        response => {
          this.initIframe(response);
        },
        error => {
          if (error.status === HttpStatus.NOT_FOUND) {
            this.signatureService.errorState = SignatureState.NOT_FOUND;
          } else if (error.status === HttpStatus.INTERNAL_SERVER_ERROR || error.status === HttpStatus.BAD_REQUEST) {
            this.signatureService.errorState = SignatureState.ERROR;
          }
        }
      );
  }

  private initIframe(response: any) {
    const body: any = response;
    this.signatureService.setUrlSignature(this.sanitizer.bypassSecurityTrustResourceUrl(body.UrlEframe));
    this.idStatus = body.IdStatus;
    this.hasValidSepaMandate = body.HasValidSepaMandate;
    this.isPayer = body.IsPayer;

    if (this.isPayer && !this.hasValidSepaMandate) {
      this.isOrderAndSepaSign = true;
      this.unsignedBdcPdf = this.domSanitize.bypassSecurityTrustResourceUrl(
        this.referenceService.staticReferences.ApiServer + this.referenceService.staticReferences.ApiVersion
        + 'BonCommande/GetUnsignedDocument/' + this.docId + '/' + this.hashSecurity
      );

      if (this.idStatus === SignStatus.INPROGRESS) {
        this.trackingService.pushEvent('financial-bdc_and_sepa_signature');
        this.ngxSmartModalService.open('welcomeMsgOrderSepaSignModal');
      }
    } else {
      if (this.idStatus === SignStatus.INPROGRESS) {
        this.trackingService.pushEvent('financial-bdc_only_signature');
        this.loaderService.increaseLoaderCount();
      }

      switch (this.idStatus) {
        case SignStatus.CANCELED:
          this.signatureService.errorState = SignatureState.SIGNATURE_CANCELED;
          break;
        case SignStatus.EXPIRED:
          this.signatureService.errorState = SignatureState.SIGNATURE_EXPIRED;
          break;
        case SignStatus.INPROGRESS:
          this.signatureService.errorState = SignatureState.READY_TO_SIGN;
          break;
        case SignStatus.SIGNED:
          this.signatureService.errorState = SignatureState.SIGNED;
          break;
      }
    }

    if (this.isOrderAndSepaSign) {
      this.pageTitle = 'Souscription aux services';
    } else {
      this.pageTitle = 'Signer votre bon de commande';
    }
    this.loaderService.decreaseLoaderCount();
  }

  ngOnInit() {
    this.getUrlSignature();
  }

  public goToSepaLink() {
    this.loaderService.increaseLoaderCount();
    this.httpServices.getWithoutAuth<SEPALinkInformationFromQuoteResponse>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_MANDAT_SEPA_LINK]
        .replace('{0}', this.docId).replace('{1}', this.hashSecurity), null)
      .subscribe(
        response => {
          this.loaderService.decreaseLoaderCount();
          if (this.isOrderAndSepaSign) {
            this.router.navigate(['sepa-sign/' + response.IdTiers + '/' + response.SupplierId + '/' + response.Hash],
              { queryParams: { orderId: this.docId, orderHash: this.hashSecurity } });
          } else {
            this.router.navigate(['sepa-sign/' + response.IdTiers + '/' + response.SupplierId + '/' + response.Hash]);
          }
        },
        error => {
          switch (error.status) {
            case HttpStatus.CONFLICT: {
              this.signatureSepaErrorState = SignatureState.SIGNED;
              break;
            }
            case HttpStatus.NOT_FOUND: {
              this.signatureSepaErrorState = SignatureState.NOT_FOUND;
              break;
            }
            default: {
              this.signatureSepaErrorState = SignatureState.ERROR;
              break;
            }
          }
        }
      );
  }

  openReportError() {
    if (this.isBlockingError !== undefined) {
      this.isBlockingError = undefined;
      this.errorText = '';
      this.isErrorSent = false;
    }
    this.isErrorReport = true;
    this.trackingService.pushEvent('financial-error_reporting');
  }

  sendError() {
    this.loaderService.increaseLoaderCount();
    // tslint:disable: quotemark
    const body = {
      "ErrorType": this.isBlockingError === true ? 0 : 1,
      "ErrorMessage": this.errorText
    };
    this.httpServices.postWithoutAuth<any, any>(this.referenceService.staticReferences.Action[config.ApiKeys.POST_ERROR_BDC]
      .replace('{0}', this.docId).replace('{1}', this.hashSecurity), body, () => { }).subscribe(
        response => {
          this.isErrorSent = true;
          this.isErrorReport = false;
          if (this.isBlockingError) {
            this.idStatus = this.signStatus.CANCELED;
          }
          this.trackingService.pushEvent('financial-error_reporting-confirmation');
          this.loaderService.decreaseLoaderCount();
        }
      );
  }

}
